export const depascalize = (str: string, separator = " "): string => {
    if (!str) return "";

    return str.replace(/([a-z\d])([A-Z])/g, `$1${separator}$2`).replace(/([A-Z]+)([A-Z][a-z\d]+)/g, `$1${separator}$2`);
};

export const removeTextQuotes = (text?: string): string => {
    return text?.replace(/^["'“]|["'“]$/g, "") ?? "";
};
